import { render, staticRenderFns } from "./DetailOrEditReportWorkList.vue?vue&type=template&id=000135ce&scoped=true&"
import script from "./DetailOrEditReportWorkList.vue?vue&type=script&lang=js&"
export * from "./DetailOrEditReportWorkList.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrEditReportWorkList.vue?vue&type=style&index=0&id=000135ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000135ce",
  null
  
)

export default component.exports